import React from 'react'
import enhancer from './enhancers/passwordForm'
import { showFieldError, renderValidation } from '../../utils/validations'
import { getExceptionMessage } from '../../utils/exceptions'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { SectionSubTitle } from '../../components/Section'
import FormRow from '../../components/FormFields/FormRow'
import PasswordField from '../../components/FormFields/PasswordField'
import FormError from '../../components/FormFields/FormError'
import Fieldset from '../../components/FormFields/Fieldset'
import Button from '../../components/Button'
import CircularProgress from '../../components/CircularProgress'
import PasswordTip from '../Register/PasswordTip'

function ProfileDataForm({
  values,
  status = {},
  touched,
  errors,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit
}) {
  return (
    <form onSubmit={handleSubmit}>
      <Fieldset>
        <SectionSubTitle as='legend'>Cambiar contraseña</SectionSubTitle>
        <FormRow>
          <PasswordField
            name='password'
            label='Nueva contraseña'
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('password', { errors, touched })}
            help={renderValidation('password', { errors, touched })}
            tip={<PasswordTip value={values.password} />}
          />
          <Button type='submit' size='s'>
            Cambiar contraseña
            {isSubmitting && <CircularProgress size={18} />}
          </Button>
        </FormRow>
        {status.error && (
          <FormError>
            <FormattedMessage {...getExceptionMessage(status.error)} />
          </FormError>
        )}
      </Fieldset>
    </form>
  )
}

export default enhancer(ProfileDataForm)
